import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class PageAdapter {
  getInputTypeonPost(inputtype: string) {
  //  
    let result: string;
    switch (inputtype) {
      case "multipleChoice": result = "mul";
        break;
      case "btn": result = "btn";
        break;
      case "checkbox": result = "chk";
        break;
      case "chklst": result = "chklst";
        break;
      case "dropdown": result = "cmb";
        break;
      case "dte": result = "dte";
        break;
      case "hdn": result = "hdn";
        break;
      case "txb": result = "txb";
        break;
      case "txa": result = "txa";
        break;
      case "lnk": result = "lnk";
        break;
      case "mul": result = "mul";
        break;
      case "radiobuttons": result = "rdo";
        break;
      case "ror": result = "ror";
        break;
      case "rot": result = "rot";
        break;
      case "txa": result = "txa";
        break;
      // case "statement": result = "txb";
      //   break;
      case "welcome": result = "wc";
        break;
      case "thankyou": result = "thk";
        break;
      case "rating": result = "rating";
        break;
        case "textbox": result = "txb";
        break;
      case "textarea": result = "txa";
        break;
        case "table": result = "table";
        break;
        case "signature": result = "sign";
        break;
        case "fileupload": result = "fileupload";
        break;
        case "matrix": result = "matrix";
        break;
      default:
        result = null;
    }
    return result;
  }

  getInputTypeonEdit(inputtype: string) {
    let result: string;
    switch (inputtype) {
      case "mul": result = "multipleChoice";
        break;
      case "btn": result = "btn";
        break;
      case "chk": result = "checkbox";
        break;
      case "chklst": result = "chklst";
        break;
      case "cmb": result = "dropdown";
        break;
      case "dte": result = "dte";
        break;
      case "hdn": result = "hdn";
        break;
      // case "txa": result = "txa";
      //   break;
      case "lnk": result = "lnk";
        break;
      case "mul": result = "mul";
        break;
      case "rdo": result = "radiobuttons";
        break;
      case "ror": result = "ror";
        break;
      case "rot": result = "rot";
        break;
      // case "txa": result = "txa";
      //   break;
      // case "txb": result = "statement";
      //   break;
      case "wc": result = "welcome";
        break;
      case "thk": result = "thankyou";
        break;
      case "rating": result = "rating";
        break;
        case "txb": result = "textbox";
        break;
      case "txa": result = "textarea";
        break;
        case "table": result = "table";
        break;
        case "sign": result = "signature";
        break;
        case "fileupload": result = "fileupload";
        break;
        case "matrix": result = "matrix";
        break;
      default:
        result = null;
    }
    return result;
  }
}

